import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import moment from "moment";
import PropTypes from "prop-types";

import { MenuItem } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import Loading from "../loading";
import Snackbar from "../snackbar";
import { listInteractStyle } from "./style";
import classNames from "classnames";
import TableFormat from "../../partials/TableFormat";
import InputFormat from "../../partials/inputForm";
import { rowsPerPage } from "../../utils/setting";
const headCells = [
  {
    key: "branch",
    numeric: false,
    disablePadding: false,
    label: "nps_listInteract_branch",
  },
  {
    key: "emotion",
    numeric: false,
    disablePadding: false,
    label: "nps_listInteract_emotion",
  },
  {
    key: "time",
    numeric: false,
    disablePadding: false,
    label: "nps_listInteract_time",
  },
];

let to = moment().endOf("month").valueOf();
let from = moment().subtract(3, "months").startOf("month").valueOf();

class ListInteract extends React.Component {
  createSortHandler = (property) => (event) => {
    this.props.onRequestSort(event, property);
  };
  state = {
    order: "desc",
    orderBy: "createdAt",
    selected: [],
    page: 0,
    rowsPerPage: rowsPerPage,
    collapse: [],
    arrange_date: {
      filter_by: "created",
      from: from || "",
      to: to || "",
    },
    statusBooking: -1,
    onTime: 60 * 60 * 1000,
    listInteract: [],
    emotion: "",
    branchCode: "",
    total: 0,
    count: 0,
  };
  componentDidMount = () => {
    this.props.onRef(this);
  };
  getDataForList = async (payload) => {
    this.loading.startLoading();
    let { branchCode, arrange_date = {}, emotion } = this.state;
    let { page, rowsPerPage } = this.mTable.state;
    let filter_exact = [];
    if (arrange_date.from && arrange_date.to) {
      arrange_date.to = moment(arrange_date.to).endOf("month").valueOf();
      arrange_date.from = moment(arrange_date.from).startOf("month").valueOf();
      if (!arrange_date.filter_by) arrange_date.filter_by = "created";
      filter_exact.push({ arrange_date: arrange_date });
    }
    if (emotion !== -1) filter_exact.push({ emotion: emotion });
    let check = await this.props.npsDispatch.getDataForList({
      branchCode: branchCode,
      filter_exact: filter_exact,
      page: page,
      limit: rowsPerPage,
      ...payload,
    });
    this.loading.stopLoading();
    if (check.code === 1) {
      this.setState({
        listInteract: check.data.list,
        total: check.data.total,
        count: check.data.count,
      });
    } else {
      this.mSnackbar.handleClick(check.message, "error");
    }
  };

  isSelected = (id) => this.state.selected.indexOf(id) !== -1;
  handleFilter = (e) => {
    let _this = this;
    this.setState({ emotion: e.target.value, selected: [] }, function () {
      _this.getDataForList();
    });
  };
  handleFilterDate = (payload) => {
    payload.from = payload.from === "" ? moment() : payload.from;
    payload.to = payload.to === "" ? moment() : payload.to;
    let _this = this;
    this.setState(
      { arrange_date: { from: payload.from, to: payload.to }, selected: [] },
      function () {
        _this.getDataForList();
      }
    );
  };
  handleChangeBranch = (branchCode) => {
    this.getDataForList({ branchCode: branchCode });
    this.setState({ branchCode: branchCode, selected: [] });
  };
  render() {
    const { classes, t, listBranch } = this.props;
    const { listInteract, emotion, total, count } = this.state;
    const { infoServiceBranch } = this.props.serviceBranchState;
    let ofBranch =
      infoServiceBranch && infoServiceBranch.branchName
        ? ` ${t("of")} ${infoServiceBranch.branchName}`
        : "";
    const filterCustom = () => {
      return (
        <div className={classes.containerCustom}>
          <InputFormat
            select
            label={t("nps_emotion")}
            placeholder={t("pls_select")}
            fullWidth={true}
            className={classes.TextField}
            value={emotion || -1}
            onChange={this.handleFilter}
            name="statusBooking"
            InputProps={{
              className: classes.rootCustom,
            }}
            size="small"
            // margin="dense"
            variant="outlined"
          >
            <MenuItem value={-1}>{t("nps_all")}</MenuItem>
            <MenuItem value={"love"}>{t("nps_love")}</MenuItem>
            <MenuItem value={"happy"}>{t("nps_happy")}</MenuItem>
            <MenuItem value={"normal"}>{t("nps_normal")}</MenuItem>
            <MenuItem value={"sad"}>{t("nps_sad")}</MenuItem>
            <MenuItem value={"angry"}>{t("nps_angry")}</MenuItem>
          </InputFormat>
        </div>
      );
    };
    return (
      <>
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <Loading onRef={(id) => (this.loading = id)} />
        <TableFormat
          onRef={(ref) => (this.mTable = ref)}
          title={t("All NPS") + ofBranch}
          headCells={headCells}
          totalCount={total}
          count={count}
          size={"medium"}
          getList={this.getDataForList}
          showFilterBranch={true}
          handleChangeBranch={this.handleChangeBranch}
          infoServiceBranch={infoServiceBranch}
          filterCustom={filterCustom}
          showCheckBox={false}
          // hiddenSearch = {true}
          rows={listInteract.map((row) => {
            let branchName = listBranch.find(
              (ele) => ele.branchCode === row.branchCode
            )
              ? listBranch.find((ele) => ele.branchCode === row.branchCode)
                  .branchName
              : "Not defined";
            let src = "/images/icon/" + row.emotion + ".svg";
            return {
              id: row._id,
              branch: branchName,
              emotion: (
                <div className={classes.emotionContainer}>
                  <img
                    className={classes.iconEmotion}
                    src={src}
                    alt="emotion"
                  />
                  <span
                    className={classNames(
                      classes.emotionText,
                      classes["" + row.emotion]
                    )}
                  >
                    {t("nps_" + row.emotion)}
                  </span>
                </div>
              ),
              time:
                new Date(row.created).toLocaleTimeString("en-US", {
                  hour: "numeric",
                  minute: "numeric",
                }) +
                " " +
                new Date(row.created).toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "2-digit",
                }),
            };
          })}
        />
      </>
    );
  }
}

ListInteract.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapState = (state) => ({
  serviceBranchState: state.serviceBranch,
  listBranch: state.serviceBranch.listBranch,
});

const mapDispatch = (dispatch) => ({
  npsDispatch: dispatch.nps,
  serviceBranchDispatch: dispatch.serviceBranch,
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(listInteractStyle)(ListInteract)));
